export default function Section6() {
    const croPoints = [
        {
            title: "Understand Audience",
            description: "Understanding what your audience expects from your website"
        },
        {
            title: "Identify Barriers",
            description: "Identifying barriers that stop users from completing a purchase or inquiry"
        },
        {
            title: "Build Trust & Improve Design",
            description: "Improving design, speed, and clarity to build trust."
        },
        {
            title: "Smoother Creation",
            description: "Creating a smoother, more intuitive user experience."
        }
    ];

    return (
        <div className="SectionCRO py-[20px] md:py-[10px] bg-[#f9f9f9]">
            {/* Section Heading */}
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    What is Conversion Rate Optimization (CRO)?
                </h2>
                <p className="mt-4 text-[#555] text-[16px] md:text-[18px] max-w-[600px] mx-auto">
                    Conversion Rate Optimization (CRO) is the process of improving your website so that more visitors take meaningful actions, such as buying a product, filling out a form, or subscribing to a service.
                </p>
                <p className="mt-4 text-[#555] text-[16px] md:text-[18px] max-w-[600px] mx-auto">
                    Instead of relying on guesswork, CRO uses data and user behavior insights to enhance your website’s performance. It focuses on:
                </p>
            </div>

            
            {/* CRO Points Grid */}
            <div className="flex flex-wrap justify-center gap-8 md:gap-12 w-[90%] md:w-[85%] mx-auto">
                {croPoints.map((point, index) => (
                    <div
                        key={index}
                        className={`p-6 w-full sm:w-[45%] md:w-[30%] rounded-2xl shadow-md text-left transition ${index % 2 === 0
                                ? "bg-[#E42E35] text-white" // red card
                                : "bg-white text-[#151515]" // white card
                            }`}
                    >
                        <h3 className="text-[18px] md:text-[20px] font-bold mb-3">
                            {point.title}
                        </h3>
                        <p className="text-[14px] md:text-[15px] leading-[22px]">
                            {point.description}
                        </p>
                    </div>
                ))}
            </div>



            {/* Summary */}
            <div className="text-center mt-12 max-w-2xl mx-auto">
                <p className="text-[#151515] !text-[16px] md:!text-[18px] font-semibold">
                    In simple terms, CRO helps you convert your current traffic into revenue without increasing your ad spend.
                </p>
            </div>
        </div>
    );
}
